// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".react-ip-input {\n  display: inline-block;\n  border: 1px solid #c2c3c9;\n  border-radius: 4px;\n  padding: 5px 8px;\n}\n\n.react-ip-input .react-ip-input__item {\n  display: inline-block;\n}\n\n.react-ip-input.has-error {\n  border-color: #a94442;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);\n}\n\n.react-ip-input input {\n  width: 30px;\n  border: none;\n  outline: none;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
